import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpArrayObject } from "../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemNameValuePair } from "../../workload/draft/CpArrayItemNameValuePair";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";

interface Props {
  index: number;
}
export const OpenTelemetry: React.FC<Props> = ({ index }) => {
  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabelTooltip>
            <CpLabel name={`logging.${index}.opentelemetry.endpoint`}>Endpoint</CpLabel>
            <CpTooltip
              tooltipProps={{
                title: "The OpenTelemetry collector endpoint URL",
              }}
            />
          </CpLabelTooltip>
          <CpInput name={`logging.${index}.opentelemetry.endpoint`} />
          <CpErrorWarning name={`logging.${index}.opentelemetry.endpoint`} />
        </CpFormItem>
        <CpArrayObject
          name={`logging.${index}.opentelemetry.headers`}
          label="Headers"
          labels={["Name", "Value"]}
          factoryFn={() => ({ id: uuidv4(), name: "", value: "" })}
        >
          <CpArrayItemNameValuePair />
        </CpArrayObject>
        <CpFormItem>
          <CpLabelTooltip>
            <CpLabel name={`logging.${index}.opentelemetry.credentials`}>Credentials</CpLabel>
            <CpTooltip
              tooltipProps={{
                title: "Optionally select an Opaque secret for authentication",
              }}
            />
          </CpLabelTooltip>
          <CpKindSelect
            kind="secret"
            queries={[{ property: "type", value: "opaque" }]}
            name={`logging.${index}.opentelemetry.credentials`}
            optionValue="name"
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.opentelemetry.credentials`} />
        </CpFormItem>
      </div>
    </>
  );
};
